const STORAGE_KEY = 'consoleBrowserId';

const generateUUID = (): string => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

/**
 * 브라우저별 영속 식별자. consoleDevice 도큐먼트 ID로 사용된다.
 * localStorage 시드. 한 번 발급되면 동일 브라우저에서 재사용.
 */
export const getBrowserId = (): string => {
  if (typeof window === 'undefined') return '';
  const existing = localStorage.getItem(STORAGE_KEY);
  if (existing) return existing;
  const generated = generateUUID();
  localStorage.setItem(STORAGE_KEY, generated);
  return generated;
};
